import Container from "./Container";
import Column from "./Column";
import Row from "./Row";

const CustomView = {
  Container,
  Column,
  Row,
};

export default CustomView;
